'use client'

import { useState } from 'react'

const INPUT_CLASSES =
  'w-full rounded-xl border border-border bg-bg px-4 py-3 text-sm text-ink placeholder:text-hint focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary'

export default function ContactForm() {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [message, setMessage] = useState('')

  return (
    <form className="mt-10 space-y-5" onSubmit={(e) => e.preventDefault()}>
      <div className="grid gap-5 md:grid-cols-2">
        <div>
          <label
            htmlFor="contact-name"
            className="text-ink mb-1.5 block text-sm font-medium"
          >
            Name
          </label>
          <input
            id="contact-name"
            type="text"
            placeholder="Your name"
            className={INPUT_CLASSES}
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div>
          <label
            htmlFor="contact-email"
            className="text-ink mb-1.5 block text-sm font-medium"
          >
            Email
          </label>
          <input
            id="contact-email"
            type="email"
            placeholder="you@example.com"
            className={INPUT_CLASSES}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
      </div>
      <div>
        <label
          htmlFor="contact-phone"
          className="text-ink mb-1.5 block text-sm font-medium"
        >
          Phone
        </label>
        <input
          id="contact-phone"
          type="tel"
          placeholder="(555) 123-4567"
          className={INPUT_CLASSES}
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />
      </div>
      <div>
        <label
          htmlFor="contact-message"
          className="text-ink mb-1.5 block text-sm font-medium"
        >
          Message
        </label>
        <textarea
          id="contact-message"
          rows={5}
          placeholder="How can we help?"
          className={INPUT_CLASSES}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />
      </div>
      <a
        href={`mailto:contact@prepsolution.com?subject=${encodeURIComponent(`Contact from ${name || 'PrepSolution visitor'}`)}&body=${encodeURIComponent(`Name: ${name}\nEmail: ${email}\nPhone: ${phone}\n\n${message}`)}`}
        className="bg-primary hover:bg-primary/90 block w-full rounded-xl px-6 py-3 text-center text-sm font-semibold text-white transition-colors"
      >
        Send Message
      </a>
    </form>
  )
}
